var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.selectableActivities,
                  "item-text": "title",
                  "item-value": "facility_key",
                  multiple: "",
                  chips: "",
                  "deletable-chips": "",
                  outlined: "",
                  dense: "",
                },
                model: {
                  value: _vm.facilityKeys,
                  callback: function ($$v) {
                    _vm.facilityKeys = $$v
                  },
                  expression: "facilityKeys",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: this.field.fieldName },
            domProps: { value: _vm.field.value },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }